import PropTypes from 'prop-types'

export function FormattedDate({ date }) {
  // TODO: check out lighterweight dayjs alternatives for the CMS
  const months = 'Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec'
  const month = months.split(' ')[date.getMonth()]
  return `${month} ${date.getDate()}, ${date.getFullYear()}`
}

FormattedDate.propTypes = { date: PropTypes.instanceOf(Date).isRequired }
